export default __webpack_public_path__ + "static/media/elevate-cbb-banner-1.31f1c962.jpg";